export default "__VITE_ASSET__CqemxjDn__"